import React from 'react'

export default function CarrotIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_522_2351)">
        <path
          d="M5.80086 8.66699L4.60502 7.47699M9.70919 9.25033L8.27419 7.81533M9.51086 5.75033C9.51086 5.75033 10.5959 4.58366 11.5525 4.58366C12.8184 4.58366 13.5942 5.75033 13.5942 5.75033C13.5942 5.75033 12.8184 6.91699 11.5525 6.91699C10.2867 6.91699 9.51086 5.75033 9.51086 5.75033ZM9.51086 5.75033C9.51086 5.75033 8.34419 4.97449 8.34419 3.70866C8.34419 2.44283 9.51086 1.66699 9.51086 1.66699C9.51086 1.66699 10.6775 2.44283 10.6775 3.70866C10.6775 4.67699 9.51086 5.75033 9.51086 5.75033ZM2.08502 13.1587C2.08502 13.1587 7.84252 11.117 9.51086 9.44866C9.75484 9.20506 9.94846 8.91578 10.0806 8.59736C10.2128 8.27893 10.281 7.93758 10.2813 7.5928C10.2816 7.24803 10.2139 6.90657 10.0822 6.58794C9.95053 6.2693 9.75737 5.97973 9.51377 5.73574C9.27017 5.49176 8.9809 5.29814 8.66247 5.16595C8.34404 5.03376 8.00269 4.96558 7.65792 4.96531C7.31314 4.96504 6.97169 5.03268 6.65305 5.16437C6.33442 5.29606 6.04484 5.48922 5.80086 5.73283C4.12669 7.40699 2.08502 13.1587 2.08502 13.1587Z"
          stroke="#6C6C6C"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_522_2351">
          <rect width="14" height="14" fill="white" transform="translate(0.760864 0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
